import { render } from "./Dropdown.vue?vue&type=template&id=45b39aa0"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/Dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b39aa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b39aa0', __exports__)) {
    api.reload('45b39aa0', __exports__)
  }
  
  module.hot.accept("./Dropdown.vue?vue&type=template&id=45b39aa0", () => {
    api.rerender('45b39aa0', render)
  })

}


export default __exports__